import React, { useRef } from 'react'
import { useHistory } from 'react-router-dom'
import Lottie from 'lottie-react'
import { Alert, AlertTitle } from '@material-ui/lab'
import { Box, Button, Typography } from '@material-ui/core'

import { SectionCard } from 'components'

import theme from 'theme'
import { routes } from 'Routes'

import successAnimation from 'images/animations/success.json'

const CompletedSection = ({ handleRequestAgain = () => {} }) => {
  const lottieRef = useRef(null)

  const history = useHistory()

  const handleRedirect = () => history.push(routes.technicalFaqs.tickets.all)

  return (
    <SectionCard title="Solicitação concluída">
      <Box display="flex" flexDirection="column" gridGap={theme.spacing(3)}>
        <Box
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
          gridGap={theme.spacing(1)}
        >
          <Lottie
            animationData={successAnimation}
            style={{ height: 200, width: 200 }}
            loop={false}
            initialSegment={[0, 130]}
            lottieRef={lottieRef}
            autoplay
          />
          <Typography variant="h3">Solicitação enviada com sucesso!</Typography>
        </Box>
        <Alert severity="success" icon={false}>
          <AlertTitle>
            Solicitação enviada ao atendimento com sucesso.
          </AlertTitle>
          A solicitação de análise do contrato foi enviada e em breve ela
          aparecerá na sua lista de solicitações.
        </Alert>
        <Alert severity="info" icon={false}>
          Se desejar enviar outro contrato para revisão, continue abaixo.
        </Alert>
        <Box
          display="flex"
          justifyContent="flex-end"
          gridGap={theme.spacing(1)}
        >
          <Button variant="contained" onClick={handleRequestAgain}>
            Enviar outro contrato
          </Button>
          <Button variant="contained" color="primary" onClick={handleRedirect}>
            Ver minhas solicitações
          </Button>
        </Box>
      </Box>
    </SectionCard>
  )
}

export default CompletedSection
